export function loadWikidataEntityToResource(entity, iriProvider, resource) {
    resource.pimHumanLabel = entity.labels;
    resource.pimHumanDescription = entity.descriptions;
    resource.pimInterpretation = entity.iri;
    resource.iri = iriProvider.cimToPim(resource.pimInterpretation);
}
//# sourceMappingURL=wd-entity-adapter.js.map